import { ref, computed } from 'vue';

const checkSourceMaster = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('source') === 'master';
};

const showJncyLayout = ref(checkSourceMaster());
const setJncyLayout = (show: boolean) => {
  showJncyLayout.value = show;
};
export const useJncyLayout = () => {
  return {
    showJncyLayout: computed(() => showJncyLayout.value),
    setJncyLayout,
  };
};
